import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AzureAuthService } from 'src/service/azure-auth.service';


@Injectable({
  providedIn: 'root'
})
export class AzureAuthGuard implements CanActivate {
  constructor(private router: Router, private azureAuthService: AzureAuthService, private guard: MsalGuard) {}

  canActivate(): boolean {
    //debugger;
    console.log("AzureAuthGuard.canActivate()");
    const auth = this.azureAuthService.isAuthenticated();
    if (auth == false){
      console.log("Not authenticated");
      this.router.navigate(['/unauthorised']);
      return false;
    }
    var account = this.azureAuthService.getAccount();
    console.log("Identity found", account);


    return true;
  }


}